<template>
  <div class="image-gallery">
    <h2>Галерея изображений</h2>

    <div v-if="pageLinks.length" class="grid">
      <button
        v-for="(link, index) in pageLinks"
        :key="index"
        class="preview-btn"
        @click="openModal(index + offset)"
      >
        <img
          :src="link"
          :alt="'Изображение ' + (index + offset + 1)"
          class="preview"
          loading="lazy"
        />
      </button>
    </div>

    <p v-else>Нет изображений для отображения.</p>

    <div class="pager" v-if="totalPages > 1">
      <button @click="prevPage" :disabled="page === 1">«</button>
      <span>Стр. {{ page }} / {{ totalPages }}</span>
      <button @click="nextPage" :disabled="page === totalPages">»</button>
    </div>

    <!-- Модальное окно -->
    <div v-if="isModalOpen" class="overlay" @click.self="closeModal">
      <button class="close" @click="closeModal">×</button>
      <img :src="currentImg" class="modal-img" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageImageGallery',
  props: {
    imageLinks: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      default: 12
    }
  },
  data() {
    return {
      page: 1,
      isModalOpen: false,
      modalIndex: 0
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.imageLinks.length / this.pageSize);
    },
    offset() {
      return (this.page - 1) * this.pageSize;
    },
    pageLinks() {
      const start = this.offset;
      const end = start + this.pageSize;
      return this.imageLinks.slice(start, end);
    },
    currentImg() {
      return this.imageLinks[this.modalIndex];
    }
  },
  methods: {
    nextPage() {
      if (this.page < this.totalPages) this.page++;
    },
    prevPage() {
      if (this.page > 1) this.page--;
    },
    openModal(globalIndex) {
      this.modalIndex = globalIndex;
      this.isModalOpen = true;
      window.addEventListener('keydown', this.onKey);
    },
    closeModal() {
      this.isModalOpen = false;
      window.removeEventListener('keydown', this.onKey);
    },
    onKey(e) {
      if (!this.isModalOpen) return;
      if (e.key === 'Escape') this.closeModal();
      if (e.key === 'ArrowRight' && this.modalIndex < this.imageLinks.length - 1) {
        this.modalIndex++;
      }
      if (e.key === 'ArrowLeft' && this.modalIndex > 0) {
        this.modalIndex--;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKey);
  }
};
</script>

<style scoped>
.image-gallery {
  padding: 1rem;
}
.grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  align-items: start; /* важен для адаптивной высоты */
}

.preview-btn {
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  width: 100%;
}

.preview {
  display: block;
  width: 100%;
  height: auto; /* ← Адаптивная высота */
  max-height: 300px; /* ← Можно ограничить, чтобы не были слишком большие */
  object-fit: contain; /* или cover, если нужно обрезать */
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  background-color: #f5f5f5;
}
.pager {
  display: flex;
  gap: .5rem;
  align-items: center;
  margin-top: 1rem;
}
.pager button {
  padding: .25rem .5rem;
}
.overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.85);
  z-index: 1000;
  padding: 1rem;
}
.modal-img {
  max-height: 90vh;
  max-width: 95vw;
  border-radius: 8px;
}
.close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 2rem;
  border: none;
  background: none;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/message-image-gallery.vue